import OriginTracing from '@atlassiansox/origin-tracing';

import { isProduction, getWacIntegrationUrl } from './environment';

function getBaseUrlForUpgrade() {
	return isProduction() ? 'https://admin.atlassian.com' : 'https://admin.stg.atlassian.com';
}

function getCCPTransactionId(entitlementId: string) {
	return `${getWacIntegrationUrl()}/gateway/api/ccp/api/v2/entitlements/${entitlementId}/details`;
}

function attachOrigin(paymentLink: string) {
	const origin = new OriginTracing({ product: 'wac-sign-up' });

	const linkWithOriginAttached = origin.addToUrl(paymentLink);
	return linkWithOriginAttached;
}

export async function generateCCPUpgradeLink(entitlementId: string, targetEdition: string) {
	const fetchEndpointUrl = getCCPTransactionId(entitlementId);
	const resp = await fetch(fetchEndpointUrl, {
		method: 'GET',
		credentials: 'include',
	});

	if (resp.ok) {
		const data = await resp.json();
		const ccpTransactionAccountId = data.transactionAccountId;

		return attachOrigin(
			`${getBaseUrlForUpgrade()}/billing/${ccpTransactionAccountId}/entitlement/${entitlementId}/change-plan?referrer=wac&offeringName=${targetEdition}`,
		);
	} else {
		throw new Error('Unsuccessful Fetch');
	}
}

export function generateHAMSUpgradeLink(
	entitlementId: string,
	productKey: string,
	targetEdition: string,
) {
	return `${getBaseUrlForUpgrade()}/s/${entitlementId}/billing/applications/change-edition/${productKey}/${targetEdition}`;
}
